/** @internal */
export const clamp = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value));

/** @internal */
export const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));
